module.exports = __webpack_public_path__ + "img/Particules_volantes2.be8ab666.svg";